import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import { Card, Form, Button, Row, Col, Table, Dropdown, Badge } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaEraser, FaTrash } from "react-icons/fa";
import faqAreasService from "../../api/faq/faqAreasService";
import { hasPerm, getCurrentUser } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';

class FAQAreas extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onChangeAtivo = this.onChangeAtivo.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaAreas = this.buscaAreas.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.state = {
            listAreas: [],
            error: "",
            busca: "", // Note: The backend API currently doesn't seem to support name filtering, only 'ativo'. But usually standard is to have it. I will leave it but if backend ignores it, it ignores it.
            ativo: "",
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount() {
        this.consultaAreas(this.state.page_numb);
    }

    consultaAreas(page_numb = 1) {
        let params = {
            page: page_numb
        };
        
        if (this.state.ativo !== "") {
            params.ativo = this.state.ativo;
        }

        this.setState({ loading: true });

        faqAreasService.getAll(params)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listAreas: response.data
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar áreas de FAQ, tente novamente.';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onChangeAtivo(e) {
        this.setState({
            ativo: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            page_numb: num_page
        }, () => {
             this.consultaAreas(num_page);
        });
    }

    buscaAreas(e) {
        e.preventDefault();
        this.setState({ page_numb: 1 }, () => {
            this.consultaAreas(1);
        });
    }

    limpaFiltro() {
        this.setState({
            busca: '',
            ativo: ''
        }, () => {
            this.consultaAreas(1);
        });
    }

    handleDelete(id) {
        Swal.fire({
            title: 'Você tem certeza?',
            text: "Esta ação não poderá ser revertida!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, deletar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                faqAreasService.delete(id)
                    .then(() => {
                        Swal.fire(
                            'Deletado!',
                            'O registro foi deletado.',
                            'success'
                        );
                        this.consultaAreas(this.state.page_numb);
                    })
                    .catch(() => {
                        Swal.fire(
                            'Erro!',
                            'Ocorreu um erro ao tentar deletar.',
                            'error'
                        );
                    });
            }
        });
    }

    renderRows() {
        if (this.state.listAreas && this.state.listAreas.results && this.state.listAreas.results.length > 0) {
            return this.state.listAreas.results.map((item) =>
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.descricao}</td>
                    <td>
                        {item.ativo ? <Badge bg="success">Sim</Badge> : <Badge bg="danger">Não</Badge>}
                    </td>
                    <td className="text-end">
                        {hasPerm('change_programas') && ( // Assuming same perm as generic config 
                            <>
                                <Link to={"/programas/faq-areas/edit/" + item.id} className="btn btn-light btn-sm">
                                    <FaRegEdit /> Editar
                                </Link>
                                <Button variant="danger" size="sm" onClick={() => this.handleDelete(item.id)} className="ms-3">
                                    <FaTrash />
                                </Button>
                            </>
                        )}
                    </td>
                </tr>
            );
        }

        return (
            <tr>
                <td colSpan={5} className="text-center">Nenhuma área cadastrada</td>
            </tr>
        );
    }

    render() {
        let dados_usuario = getCurrentUser();
        // Assuming view_programas is the permission, based on other config menus
        if (!hasPerm('view_programas') && dados_usuario['tipo_usuario'] !== '') {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Áreas de FAQ</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        {hasPerm('add_programas') && (
                            <Link to="/programas/faq-areas/add" className="btn btn-secondary btn-sm">
                                <FaPlus /> Adicionar Área
                            </Link>
                        )}
                    </Col>
                </Row>

                <Card className="cardDestaque">
                    <Card.Body>
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaSearch /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter" style={{ minWidth: '300px', padding: '15px' }}>
                                            <Form onSubmit={this.buscaAreas}>
                                                <Row>
                                                    <Col sm={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Ativo</Form.Label>
                                                            <Form.Control   
                                                                as="select" 
                                                                value={this.state.ativo} 
                                                                onChange={this.onChangeAtivo}
                                                            >
                                                                <option value="">Todos</option>
                                                                <option value="true">Sim</option>
                                                                <option value="false">Não</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <div className="d-flex justify-content-between">
                                                    <Button type="submit" variant="primary" size="sm">
                                                        Filtrar
                                                    </Button>
                                                    <Button type="button" variant="light" size="sm" onClick={this.limpaFiltro}>
                                                        <FaEraser /> Limpar
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Table responsive hover className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Descrição</th>
                                    <th>Ativo</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                    <tr>
                                        <td colSpan={5} className="text-center">Carregando...</td>
                                    </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={5} className="text-center text-danger">{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {this.state.listAreas && this.state.listAreas.results && this.state.listAreas.results.length > 0 &&
                            <Paginacao 
                                dados={this.state.listAreas} 
                                loading={this.state.loading} 
                                page_numb={this.state.page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default FAQAreas;
